var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointCoins = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7A328",
  d: "M11 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7A328",
  d: "M11 4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 7.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6M5.56 9.785A5 5 0 0 1 5.5 9q0-.445.07-.885c-.37.035-.73.05-1.07.05a10.1 10.1 0 0 1-4-.755v1.5c.315.35 1.895.91 4 .91q.532.01 1.06-.035m-1.06 1.05a10.1 10.1 0 0 1-4-.755V12c0 1.46 3.59 1.5 4 1.5a10.2 10.2 0 0 0 2.85-.39 5.5 5.5 0 0 1-1.56-2.35q-.643.073-1.29.075"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7A328",
  d: "M5.845 7.085A5.5 5.5 0 0 1 8.5 4.1V4c0-1.46-3.59-1.5-4-1.5S.5 2.54.5 4v2.255c.315.35 1.895.91 4 .91q.676 0 1.345-.08"
})));
export default SvgPointCoins;